import React from "react";
import { useNavigate } from "react-router";
import CustomButton from "../../components/form/CustomButton";

export const Columns = (openModalAdd, setModalConfirm, modalConfirm, modalFiles, setModalFiles, completeFinishLoad, loadinStatus) => {
    const navigate = useNavigate();
    let columns = [
        {
            id: 'id_supplier',
            name: 'ID SUPPLIER',
            selector: row => row.id
        },
        {
            id: 'company_name',
            name: 'COMPANY NAME',
            selector: row => row.company?.name
        },
        {
            id: 'contact_name',
            name: 'CONTACT NAME',
            selector: row => row.name
        },
        {
            id: 'email',
            name: 'EMAIL',
            selector: row => row.email
        },
        {
            id: 'phone_number',
            name: 'PHONE NUMBER',
            selector: row => row.phone
        },
        {
            id: 'service_type',
            name: 'SERVICE TYPE',
            selector: row => row.supplier_type?.name
        },
        {
            id: 'action',
            name: '',
            selector: row => (
                <div className="flex flex-col space-y-2">
                    {/* Fila inferior - editar y eliminar */}
                    <div className="flex items-center space-x-2">
                        <button onClick={() => openModalAdd(row)} className="flex items-center justify-center px-4 py-2 border-r hover:bg-gray-100">
                            <i className="fas fa-pen text-gray-500"></i>
                        </button>
                        <button onClick={() => setModalConfirm({ ...modalConfirm, show: true, id: row.id })} className={`flex items-center justify-center px-4 py-2 hover:bg-gray-100`}>
                            <i className={`fas fa-trash text-red-500`}></i>
                        </button>
                    </div>
                </div>
            ),
        },
    ];
    return columns;
}